import { Button, Modal } from '@seiue/ui'
import { useContext } from 'react'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'

import { getTheme } from '@/utils/theme'

import { UserPluginContextParam } from '../../utils/type'
import { UserPluginContext } from '../../utils/util'
import { SelectReflectionModal } from '../SelectReflectionModal'

/**
 * 用户选择卡片
 *
 * @param param - 参数
 * @param param.showCard - 是否显示
 * @returns 组件
 */
export const SelectScope: React.FC<{
  showCard: boolean
}> = ({ showCard }) => {
  const theme = getTheme()

  const { scopes, setScopes, selectNames, setSelectNames } =
    useContext<UserPluginContextParam>(UserPluginContext)

  return (
    <SelectCard showCard={showCard}>
      <SelectCardTitle>{'授权成员'}</SelectCardTitle>
      {selectNames.length > 0 ? (
        <SelectList>
          {selectNames
            .filter((e, key) => key <= 8)
            .map((e, key) => {
              return (
                <div key={key}>
                  {key == 8 ? (
                    <EllipsisItem
                      key={key}
                    >{`等 ${selectNames.length} 个成员`}</EllipsisItem>
                  ) : (
                    <SelectItem key={key}>{e}</SelectItem>
                  )}
                </div>
              )
            })}
        </SelectList>
      ) : null}

      {selectNames.length === 0 ? (
        <StyledButton
          type="text"
          onClick={() => {
            const { hide } = Modal.open({
              header: null,
              footer: null,
              fullScreen: true,
              bodyStyle: { padding: 0 },
              children: (
                <SelectReflectionModal
                  onClose={() => {
                    hide()
                  }}
                  scopes={scopes}
                  setScopes={setScopes}
                  setSelectNames={setSelectNames}
                />
              ),
            })
          }}
        >
          <GrowpIcon
            name="Jiahao"
            color={theme.brand._1}
            size={14}
            text="添加"
          />
        </StyledButton>
      ) : (
        <StyledButton
          type="text"
          onClick={() => {
            const { hide } = Modal.open({
              header: null,
              footer: null,
              fullScreen: true,
              bodyStyle: { padding: 0 },
              children: (
                <SelectReflectionModal
                  onClose={() => {
                    hide()
                  }}
                  scopes={scopes}
                  setScopes={setScopes}
                  setSelectNames={setSelectNames}
                />
              ),
            })
          }}
        >
          <GrowpIcon
            name="Edit"
            color={theme.brand._1}
            size={14}
            text="编辑"
          />
        </StyledButton>
      )}
    </SelectCard>
  )
}

const SelectCard = styled.div<{ showCard: boolean }>`
  display: ${(props) => (props.showCard ? 'flex' : 'none')};
  min-height: 78px;
  border-radius: 8px;
  flex-direction: column;
  padding: 12px;
  align-self: stretch;
  margin-top: 16px;
  width: 100%;
  background-color: ${(props) => props.theme.background._4};
  gap: 8px;
`

const SelectCardTitle = styled.div`
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  height: 22px;
  color: ${(props) => props.theme.text._3};
`

const SelectList = styled.div`
  width: 100%;
  max-height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`

const SelectItem = styled.div`
  height: 28px;
  border-radius: 6px;
  align-items: center;
  padding: 3px 8px;
  border: 1px solid ${(props) => props.theme.border.greyNormal};
  color: ${(props) => props.theme.text._1};
`

const EllipsisItem = styled.div`
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: ${(props) => props.theme.text._1};
`

const StyledButton = styled(Button)`
  display: flex;
  width: 16px;
`
